import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Table, TableBody, TableRow, TableHead } from '@mui/material';
import DocumentSignatureBookmarkComponent from './DocumentTemplateSignatureBookmarkListItemComponent';
import CardNoResultsWrapper from 'components/layout/CardNoResultsWrapper';
import { TableCellWithWidth } from 'components/list/TableComponentsStyled';

const DocumentTemplateSignatureBookmarkListComponent = ({
  documentTemplate,
  validation,
  signatureActors,
  onPropertyChanged,
  onLookupPropertyChanged,
  onAddNewBookmark,
  onBookmarkDeleted
}) => {
  const [t] = useTranslation();

  return (
    <CardNoResultsWrapper content={documentTemplate?.signatureBookmarks}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCellWithWidth w={15}>{t('DocumentTemplate.Name')}</TableCellWithWidth>
            <TableCellWithWidth w={10}>{t('DocumentTemplate.IsTable')}</TableCellWithWidth>
            <TableCellWithWidth w={25}>{t('DocumentTemplate.Actors')}</TableCellWithWidth>
            <TableCellWithWidth w={40}>{t('DocumentTemplate.GeneratedBookmarks')}</TableCellWithWidth>
            <TableCellWithWidth w={10}>{t('RequiredDocument.Actions')}</TableCellWithWidth>
          </TableRow>
        </TableHead>
        <TableBody>
          {documentTemplate?.signatureBookmarks.map((item, idx) => {
            return (
              <DocumentSignatureBookmarkComponent
                signatureBookmark={item}
                signatureActors={signatureActors}
                index={idx}
                key={idx}
                validation={validation}
                onDelete={onBookmarkDeleted(idx)}
                onPropertyChanged={onPropertyChanged(idx)}
                onLookupPropertyChanged={onLookupPropertyChanged(idx)}
                onAddNewBookmark={onAddNewBookmark}
              />
            );
          })}
        </TableBody>
      </Table>
    </CardNoResultsWrapper>
  );
};

DocumentTemplateSignatureBookmarkListComponent.propTypes = {
  validation: PropTypes.object.isRequired,
  documentTemplate: PropTypes.object.isRequired,
  signatureActors: PropTypes.array,
  onPropertyChanged: PropTypes.func.isRequired,
  onLookupPropertyChanged: PropTypes.func.isRequired,
  onAddNewBookmark: PropTypes.func.isRequired,
  onBookmarkDeleted: PropTypes.func.isRequired
};

export default DocumentTemplateSignatureBookmarkListComponent;
